/** @jsxImportSource @emotion/react */

import { Box, Modal, css } from "@mui/material";
import MuiModal from "component/atom/MuiModal";
import { BsYoutube } from "react-icons/bs";
// import { SiKakao } from "react-icons/si";
// import { useEffect, useState } from "react";

interface PlaceMapModalProps {
    modalOpen: boolean,
    handleClose: any,
    info: any
}

export default function PlaceMapModal({modalOpen, handleClose, info}: PlaceMapModalProps) {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4
    };

    const settingImage = (info: any) => {
        if(!info) return

        let tmpImageSrc = require("../../assets/images/baek_jong_won.png")
        if(info.category.includes("백종원")){
            tmpImageSrc = require("../../assets/images/baek_jong_won.png")
        } else if(info.category.includes("성시경")){
            tmpImageSrc = require("../../assets/images/seong_si_kyung.png")
        } else if(info.category.includes("먹보스")){
            tmpImageSrc = require("../../assets/images/hyun_joo_yup.png")
        } else if(info.category.includes("최자")){
            tmpImageSrc = require("../../assets/images/chioza.png")
        } else if(info.category.includes("풍자")){
            tmpImageSrc = require("../../assets/images/pung_ja.png")
        }
        return tmpImageSrc
    }

    return(
        <>
            <div>
                <MuiModal
                    open={modalOpen}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <div css={TopContentsStyle}>
                            <div css={TitleStyle}>
                                {info?.title}
                            </div>
                            <div css={AddressStyle}>
                                {`(${info?.addr1})`}
                            </div>
                            <div css={PhoneStyle}>
                                {info?.phone}
                            </div>
                            <div css={ThumbnailStyle}>
                                <img src={info?.image_url ? info?.image_url : settingImage(info)} alt="test" css={ThumbnailImageStyle} />
                            </div>
                        </div>
                        <div css={BottomContentsStyle}>
                            {info?.youtube &&
                                <div css={YoutubeContentsStyle}>
                                    <div css={YoutubeIconStyle}>
                                        <BsYoutube color="red" />
                                        &nbsp; YOUTUBE
                                    </div>
                                    <div css={YoutubeShortcutStyle}>
                                        YOUTUBE 바로가기
                                    </div>
                                </div>
                            }
                            {/* <div css={KakaoContentsStyle}>
                                <div css={KakaoIconStyle}>
                                    <SiKakao />
                                    &nbsp; KAKAO
                                </div>
                                <div css={KakaoShortcutStyle}>
                                    KAKAO 바로가기
                                </div>
                            </div> */}
                            <div css={MainMenuStyle}>
                                주메뉴
                            </div>
                            <div css={MenuListStyle}>
                                {info?.menu}
                            </div>
                            {/* <div css={ButtonListStyle}>
                                <div css={ModifyRequestButtonStyle}>정보 정정요청</div>
                                <div css={DetailButtonStyle}>페이지 상세보기</div>
                            </div> */}
                        </div>
                    </Box>
                </MuiModal>
            </div>
        </>
    )
}

const TopContentsStyle = css`
    padding-bottom: 12.6px;
    border-bottom: 2px solid #000;
`

const TitleStyle = css`
    font-size: 21px;
    color: #000;
    font-weight: 700;
`

const AddressStyle = css`
    font-size: 15.4px;
    color: #000;
    font-weight: 700;
    margin-bottom: 5px;
`

const PhoneStyle = css`
    font-size: 15.4px;
    color: #289997;
    font-weight: 400;
`

const ThumbnailStyle = css`
    width: 100%;
    overflow: hidden;
    transition: all 0.3s ease;
    margin-top: 10px;
    background: #f7f7f7;
`

const ThumbnailImageStyle = css`
    width: 100%;
    object-fit: cover;
`

const BottomContentsStyle = css`
    font-size: 16.8px;
    margin-top: 10px;
`

const YoutubeContentsStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`

const YoutubeIconStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const YoutubeShortcutStyle = css`
    font-size: 11.4px;
    color: #289997;
    margin-bottom: 2px;
    padding-bottom: 1px;
    border-bottom: 1px solid currentColor;
`

const KakaoContentsStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`

const KakaoIconStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const KakaoShortcutStyle = css`
    font-size: 11.4px;
    color: #289997;
    margin-bottom: 2px;
    padding-bottom: 1px;
    border-bottom: 1px solid currentColor;
`

const MainMenuStyle = css`
    position: relative;
    font-size: 13.1px;
    color: #000;
    font-weight: 600;
    margin-top: 17.5px;
    ::after{
        content: '';
        position: absolute;
        left: 0px;
        top: 8px;
        width: calc(100% - 43.8px);
        height: 1px;
        background: #c1c1c1;
        margin-left: 43.8px;
    }
`

const MenuListStyle = css`
    font-size: 13.1px;
    color: #666;
    font-weight: 400;
    margin-top: 5px;
`

const ButtonListStyle = css`
    display: flex;
    justify-content: center;
    gap: 17.5px;
    padding-top: 8.8px;
    text-align: center;
`

const ModifyRequestButtonStyle = css`
    font-size: 12.3px;
    color: #d32c26;
    font-weight: 400;
`

const DetailButtonStyle = css`
    font-size: 12.3px;
    color: #000;
    font-weight: 400;
`